import React from 'react';
import { useNavigate } from 'react-router-dom';
import './statusPages.css';

import openBook from '../assets/imgs/openBook.png';

const Error404 = () => {
  const navigate = useNavigate();

  return (
    <main className="statusPage">
      <button className="statusClose" onClick={() => navigate(-1)}>
        ×
      </button>

      <img src={openBook} alt="Open book" />

      <h1>Sorry we couldn’t load this page</h1>
      <p>You appear to be offline, please reconnect and try again.</p>

      <button className="statusBtn" onClick={() => window.location.reload()}>
        Try again
      </button>
    </main>
  );
};

export default Error404;